<template>
    <div class="container-fluid">
        <h1
            class="page-title"
            v-if="!postcode.id"
        >
            New Postcode Fee
        </h1>
        <h1
            class="page-title"
            v-if="postcode.id"
        >
            Edit Postcode Fee
        </h1>
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="save()"
                >
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="area_name">Area Name</label>
                                <input
                                    type="text"
                                    id="area_name"
                                    placeholder="Area Name"
                                    v-model="postcode.area_name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.area_name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.area_name"
                                >{{ errors.area_name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="postcode">Postcode</label>
                                <input
                                    type="text"
                                    id="postcode"
                                    placeholder="Postcode"
                                    v-model="postcode.postcode"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.postcode }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.postcode"
                                >{{ errors.postcode[0] }}</small>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="service_fee">Service Fee</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">£</span>
                                        </div>
                                        <input
                                            type="number"
                                            id="service_fee"
                                            step="0.01"
                                            min="0"
                                            placeholder="10.00"
                                            v-model="postcode.service_fee"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.service_fee }"
                                        >
                                    </div>
                                    <small
                                        class="form-error"
                                        v-if="errors.service_fee"
                                    >{{ errors.service_fee[0] }}</small>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="unit_fee">Unit Fee</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">£</span>
                                        </div>
                                        <input
                                            type="number"
                                            id="unit_fee"
                                            step="0.01"
                                            min="0"
                                            placeholder="10.00"
                                            v-model="postcode.unit_fee"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.unit_fee }"
                                        >
                                    </div>
                                    <small
                                        class="form-error"
                                        v-if="errors.unit_fee"
                                    >{{ errors.unit_fee[0] }}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button
                                        type="submit"
                                        class="btn btn-primary"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        v-if="postcode.id"
                                        @click="deletePostcode(postcode)"
                                        class="btn btn-outline-danger"
                                    >
                                        <i class="fa fa-times" /> Delete
                                    </button>
                                    <button
                                        type="button"
                                        @click="$router.go(-1)"
                                        class="btn btn-outline-secondary"
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Service from "../../../services/PostcodeFeeService";

export default {
    props: ["id"],
    data: function() {
        return {
            postcode: {},
            errors: {}
        };
    },
    mounted: function() {
        if (this.id) {
            Service.get(this.id).then(
                res => {
                    this.postcode = res.data;
                },
                err => {
                    alert("Error: Could not load postcode");
                }
            );
        }
    },
    methods: {
        save: function() {
            this.errors = {};
            if (this.postcode.id) {
                Service.update(this.postcode).then(
                    res => {
                        this.postcode = res.data;
                        alert("Postcode saved");
                    },
                    err => {
                        this.errors = err.response.data.errors;
                    }
                );
            } else {
                Service.create(this.postcode).then(
                    res => {
                        this.postcode = res.data;
                        alert("Postcode saved");
                        this.$router.push({
                            name: "office.postcode_fees.edit",
                            params: { id: this.postcode.id }
                        });
                    },
                    err => {
                        this.errors = err.response.data.errors;
                    }
                );
            }
        },
        deletePostcode: function(postcode) {
            if (confirm("Are you sure you want to delete this postcode fee?")) {
                Service.delete(postcode).then(res => {
                    alert("Postcode deleted successfully");
                    this.$router.push({ name: "office.postcode_fees.search" });
                });
            }
        }
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/postcode-fees/CreateComponent.vue